import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDartDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 57,
	height: 56,
	viewBox: "0 0 57 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.711 12.2122C12.711 12.2122 22.8165 7.16247 27.8682 4.63461C28.7876 4.18136 29.8057 3.96483 30.83 4.00465C32.3619 4.09864 34.1838 5.58056 34.1838 5.58056L52.4988 23.8976V43.4745H43.9733V52H24.0784L6.07938 34.001C5.10743 33.0011 4.50146 31.5911 4.50146 30.2112C4.50146 29.5732 4.86145 28.5753 5.13343 28.0013L12.711 12.2122ZM14.0689 13.5701V37.1428C14.0729 38.2288 14.1109 39.1907 15.0649 40.1587L24.9083 50.0001H41.9734V41.4746L14.0689 13.5701ZM38.1776 12.2142C36.3797 10.4223 34.5598 8.65439 32.6979 6.92849C32.0939 6.39452 31.564 5.99254 30.558 6.00454C29.8181 6.03254 28.8181 6.39452 28.8181 6.39452L17.1828 12.2122L38.1776 12.2142Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDartDark);
export { ForwardRef as ReactComponent };
